import { lazy } from 'react';
import Cookies from 'js-cookie'
// project imports
// import Loadable from 'ui-component/Loadable';
// import MinimalLayout from 'layout/MinimalLayout';
import AuthLogin from '../views/pages/AuthLogin';
import AuthOTPVerification from '../views/pages/AuthOTPVerification';
import LoginScreen from '../views/pages/LoginScreen';
import OTPScreen from '../views/pages/OTPScreen';
import StartupDetail from '../views/startupDetail';
import PitchDeck from '../views/PitchDeck';
import OnboardingLayout from 'layout/MainContent/OnboardingLayout';
import AuthLayout from 'layout/MainContent/AuthLayout';
import { Outlet } from 'react-router-dom';
import SingleSignOn from 'views/pages/SingleSignOn';

// // login option 3 routing
// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '',
    element: <Outlet />,
    children: [
        // {
        //     path: '/',
        //     element: <Login />,
        // },
        {
            path: '/',
            element: <AuthLayout><AuthLogin /></AuthLayout>,
        },
        {
            path: '/verification',
            element: <AuthLayout><AuthOTPVerification /></AuthLayout>,
        },
        {
            path: '/cHJpdmF0ZS1yb3V0ZQ==',
            element: <OnboardingLayout><SingleSignOn /></OnboardingLayout>,
        },
        {
            path: '/callback',
            element: <AuthLayout><AuthLogin /></AuthLayout>,
        },
        {
            path: '*',
            element: <AuthLayout><AuthLogin /></AuthLayout>,
        },
    ]
};

export default AuthenticationRoutes;
